import { TransportTypesE } from '../enums/common';
import { TransportTypeT } from '../interfaces/transports';

export const TRANSPORTS: TransportTypeT[] = [
  {
    transportType: TransportTypesE.CAR,
    vehicles: [
      {
        code: 'GAS_PASSENGER_CARS_SINCE_2009',
        displayName: {
          en: 'Car',
          pt: 'Carro',
          es: 'Coche',
          fr: 'Voitures particulières à essence 2009 - présent',
        },
      },
      {
        code: 'GAS_LIGHT_DUTY_TRUCKS_SINCE_2008',
        displayName: {
          en: 'Truck',
          pt: 'Camionete',
          es: 'Camioneta',
          fr: 'Camions utilitaire léger à essence depuis 2008',
        },
      },
    ],
  },
  {
    transportType: TransportTypesE.PLANE,
    vehicles: [
      {
        code: 'SEATING_UNKNOWN',
        displayName: {
          en: 'Seating Unknown',
          pt: 'Assento desconhecido',
          es: 'Asiento desconocido',
          fr: 'Siège inconnu',
        },
      },
      {
        code: 'ECONOMY',
        displayName: {
          en: 'Economy Class',
          pt: 'Classe econômica',
          es: 'Clase económica',
          fr: 'Classe économique',
        },
      },
      {
        code: 'ECONOMY_PLUS',
        displayName: {
          en: 'Economy Plus Class',
          pt: 'Classe econômica Plus',
          es: 'Clase económica Plus',
          fr: 'Classe économique plus',
        },
      },
      {
        code: 'FIRST',
        displayName: {
          en: 'First Class',
          pt: 'Primeira Classe',
          es: 'Primera Clase',
          fr: 'Première classe',
        },
      },
      {
        code: 'BUSINESS',
        displayName: {
          en: 'Business Class',
          pt: 'Classe Executiva',
          es: 'Clase Ejecutiva',
          fr: 'Classe affaires',
        },
      },
    ],
  },
  {
    transportType: TransportTypesE.BUS,
    vehicles: [
      {
        code: 'BUS',
        displayName: {
          en: 'Bus',
          pt: 'Ônibus',
          es: 'Autobús',
          fr: 'Bus',
        },
      },
    ],
  },
  {
    transportType: TransportTypesE.TRAIN,
    vehicles: [
      {
        code: 'TRAM_SUBWAY_LIGHT_LIGHT_RAIL',
        displayName: {
          en: 'Tram, Subway, Light Rail',
          pt: 'Trem, Metrô',
          es: 'Tren, Metro',
          fr: 'Tram, Métro, Métro léger',
        },
      },
      {
        code: 'NATIONAL_RAIL',
        displayName: {
          en: 'National Rail',
          pt: 'Ferrovia Nacional',
          es: 'Ferrocarril nacional',
          fr: 'Chemin de fer national',
        },
      },
    ],
  },
  {
    transportType: TransportTypesE.BOAT,
    vehicles: [
      {
        code: 'YACHT',
        displayName: {
          en: 'Yacht Under 78ft',
          pt: 'Late com menos de 78 pés',
          es: 'Yate de menos de 78 pies',
          fr: 'Yacht inférieur à 78ft',
        },
      },
      {
        code: 'SUPERYACHT',
        displayName: {
          en: 'Superyacht Over 78ft',
          pt: 'Superiate com mais de 78 pés',
          es: 'Superyate de más de 78 pies',
          fr: 'Superyacht de plus de 78ft',
        },
      },
      {
        code: 'FERRY_NO_VEHICLES',
        displayName: {
          en: 'Ferry No Vehicles',
          pt: 'Balsa sem veículos',
          es: 'Ferry sin vehículos',
          fr: 'Ferry sans véhicules',
        },
      },
      {
        code: 'FERRY_WITH_VEHICLES',
        displayName: {
          en: 'Ferry Vehicles',
          pt: 'Balsa com veículos',
          es: 'Ferry con vehículos',
          fr: 'Ferry Véhicules',
        },
      },
      {
        code: 'PERSONAL_BOAT',
        displayName: {
          en: 'Personal Boat',
          pt: 'Barco próprio',
          es: 'Embarcación propia',
          fr: 'Bateau privé',
        },
      },
    ],
  },
];
